<ng-container *ngIf="disclaimer$ | async as disclaimer">
  <div class="cc-footer-disclaimer" *ngIf="disclaimer.length">
    <div *ngFor="let text of disclaimer" [innerHTML]="text | bypassHtmlSecurity"></div>
  </div>
</ng-container>
